module.exports = __webpack_public_path__ + "static/ios-88c976cfd2a3f34dac8ad8987308234d.svg";